import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FileService } from 'src/app/services/api/file.service';
import { FunctionsService } from 'src/app/services/api/functions.service';
import { LoadingService } from 'src/app/services/loading.service';
import { FileModel } from '../../../app/model/file/model.file';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogArchivosReservasComponent } from './dialog-archivos-reservas/dialog-archivos-reservas.component';

//import { MY_FORMATS } from 'src/app/helpers/datesFormat';
import { Router } from '@angular/router';
import * as moment from 'moment';

import { firstValueFrom } from 'rxjs';
import { getFileDisplayState } from 'src/entities/file';
import { flattenStrings } from 'src/shared/lib';
import { DialogPdfComponent } from 'src/app/programacion-aventura/dialog-pdf/dialog-pdf.component';
import {
  projectionExpressionFiles,
  projectionExpressionServicios
} from './filterExpreesion';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.css']
})
export class ServicesComponent implements OnInit {
  selectedValue: string = '';
  dataItinial: FileModel[] = [];
  filtersSecction: boolean = false;
  loader: boolean = false;
  selectedFile: string | null = null;
  fileDataSource = new MatTableDataSource<FileModel>();
  estadoBtnMasivo: any = 0;
  messageButtonOS: any = null;
  model: any;
  resultOS: any;
  fileDisplayedColumns: string[] = [
    'fileDisplayState',
    'nameEmpresa',
    'fileNumber',
    'dateRange',
    'nombreServicio',
    'nombreProveedor',
    'numReserva',
    'numOS',
    'estadoReserva',
    'archivos'
  ];

  startDate: Date | any;
  endDate: Date | any;
  startDate2: Date | any;
  endDate2: Date | any;
  startDateSelected2: Date | any;
  endDateSelected2: Date | any;

  startDateSelected: Date | any;
  endDateSelected: Date | any;
  daySelected: string | null = null;
  selectFile: String | null = null;
  typeOfServiceSelected: String | null = null;
  categoriaOfServiceSelected: String | null = null;

  selectedCliente: string | null = null;
  selectService: String | null = null;
  selectDate: String | null = null;
  selectNumOS: String | null = null;
  selectEstadoReserva: String | null = null;
  selectEstadoOS: string | null = null;
  selectProveedor: string | null = null;

  selectEstadoFile: String | null = null;
  selectClient: String | null = null;
  selectNumberFile: String | null = null;

  arrayDays: any[] | null = null;
  arrayFiles: any[] | null = null;
  arrayTypesOfService: any[] | null = null;
  arrayCategoriasOfService: any[] | null = null;
  arrayClientes: any = [];
  arrayProveedores: any = [];

  arrayServices: any[] | null = null;
  arrayDates: any[] | null = null;
  arrayClients: any[] | null = null;
  arrayEstadoFile: any[] | null = null;
  arrayNumOS: any[] | null = null;
  arraySelectEstadoOS: any = ['CONFIRMADO', 'RECHAZADO', 'EN ESPERA'];
  arrayEstadoFiles: any = [
    'APROBADO',
    'NO APROBADO',
    'NUEVO PEDIDO',
    'LAST MINUTE',
    'REVISAR',
    'ANULADO',
    'POSTERGADO',
    'EN PROCESO',
    'CONFIRMADO',
    'RECONFIRMADO',
    'PROGRAMADO',
    'EN OPERACION',
    'OPERADO',
    'CERRADO'
  ];

  toppingList: any[] | null = null;

  usuario: string = '';
  categoriasFiltradas: string[] = [];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort!: MatSort;

  constructor(
    private fileService: FileService,
    private changeDetectorRefs: ChangeDetectorRef,
    private router: Router,
    public loadingService: LoadingService,
    private functions: FunctionsService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.loader = true;
    this.arrayEstadoFile = [
      'APROBADO',
      'NO APROBADO',
      'NUEVO PEDIDO',
      'LAST MINUTE',
      'REVISAR',
      'ANULADO',
      'POSTERGADO',
      'EN PROCESO',
      'CONFIRMADO',
      'RECONFIRMADO',
      'PROGRAMADO',
      'EN OPERACION',
      'OPERADO',
      'CERRADO'
    ];

    // this.functions.disparadorCambios.subscribe((tipo: string) => {
    //   this.loadServices();
    // });
    // this.loadServices();
  }

  async ngAfterViewInit() {
    try {
      // 1️⃣ Obtén los itinerarios
      const [resultadoGetAllItinerarios] = await Promise.all([
        this.getAllFilesPaginated()
      ]);
      console.log('todas las funciones principales completadas.');

      // 2️⃣ Crea lista única de IDs
      const itinerariesIds: string[] = [
        ...new Set(resultadoGetAllItinerarios.map((i: any) => i.id))
      ];

      // 3️⃣ Procesa en lotes de N (por ejemplo, 20)
      const batchSize = 20;
      const serviciosByIdItinerarios: any[] = [];

      for (let i = 0; i < itinerariesIds.length; i += batchSize) {
        const batch = itinerariesIds.slice(i, i + batchSize);
        const promesasBatch = batch.map((id: string) =>
          this.getServicesByFileID(id, projectionExpressionServicios.join(','))
        );

        console.log(
          `Procesando lote ${Math.floor(i / batchSize) + 1} de ${Math.ceil(
            itinerariesIds.length / batchSize
          )}`
        );

        // Espera que se resuelvan solo las promesas del lote actual
        const resultadosBatch = await Promise.all(promesasBatch);
        serviciosByIdItinerarios.push(...resultadosBatch.flat());
      }

      console.log(
        'serviciosByIdItinerarios.length:',
        serviciosByIdItinerarios.length
      );

      // 4️⃣ Combina datos con itinerarios
      const lstServices: any[] = [];
      for (const file of resultadoGetAllItinerarios) {
        const servicios = serviciosByIdItinerarios.filter(
          (serv: any) => serv.idItinerary === file.id
        );
        for (const serv of servicios) {
          lstServices.push({
            ...serv,
            fileDisplayState: file.fileDisplayState,
            fileNumber: file.fileNumber,
            fileName: file.fileName,
            dateRange: file.dateRange
          });
        }
      }

      console.log('lstServices.length:', lstServices.length);
      this.loadServices(lstServices);
    } catch (error) {
      console.error('Error en ngAfterViewInit:', error);
    }
  }

  async getAllFilesPaginated() {
    try {
      let LastEvaluatedKey = null;
      let hasMore = true;
      let resultFiles: any[];
      let data: any;
      let files: any[] = [];
      while (hasMore) {
        data = await firstValueFrom(
          this.fileService.getAllItinerariesPaginacion({
            key: LastEvaluatedKey,
            projectionExpression: projectionExpressionFiles.join(',')
          })
        );

        hasMore = data?.getAllItinerariesPaginacion?.isThereMore;
        resultFiles = data?.getAllItinerariesPaginacion?.resultFiles.map(
          (file: any) => ({
            ...file,
            fileDisplayState: getFileDisplayState({
              pendingPreOpIncidents: file.pendingPreOpIncidents,
              estadoFile: file.estadoFile,
              estadoItinerario: file.estadoItinerario,
              lastMinute: file.lastMinute
            })
          })
        );
        files = [...files, ...resultFiles];
        LastEvaluatedKey = data?.getAllItinerariesPaginacion?.LastEvaluatedKey;
      }

      return files;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  async getServicesByFileID(id: String, projectionExpression?: string) {
    try {
      const result = await firstValueFrom(
        this.fileService.getServicesByFileID(id, projectionExpression)
      );

      return result.getServicesByFileID ?? [];
    } catch (error: any) {
      throw new Error(error);
    }
  }

  loadServices(allServices: any[]) {
    // this.loader = true;

    // this.fileService.getAllServicesReservas().subscribe({
    //   next: (data) => {
    //     console.log('DATA');
    //     console.log(data.getAllServicesReservas);

    //     const allServices = data.getAllServicesReservas;

    this.arrayDays = [...new Set(allServices.map((item: any) => item.day))];
    this.arrayFiles = [
      ...new Set(allServices.map((item: any) => item.fileNumber))
    ];
    this.arrayTypesOfService = [
      ...new Set(allServices.map((item: any) => item.tipoServicio))
    ];
    this.arrayDates = [...new Set(allServices.map((item: any) => item.date))];
    this.arrayNumOS = [...new Set(allServices.map((item: any) => item.numOS))];

    this.arrayProveedores = [
      ...new Set(allServices.map((item: any) => item.objProvider?.nombre))
    ];
    this.arrayClients = [
      ...new Set(allServices.map((item: any) => item.fileName))
    ];
    this.arrayClientes = [
      ...new Set(allServices.map((item: any) => item.fileName))
    ];

    this.model = allServices.map((item: any) => ({
      ...item,
      nombreProveedor: item.objProvider?.nombre
    }));

    const typesOfService = [...new Set(this.arrayTypesOfService)];
    this.arrayCategoriasOfService = [];

    for (const tipo of typesOfService) {
      const categoriasSet = new Set();

      allServices
        .filter((item: any) => item.tipoServicio === tipo)
        .forEach((item: any) => {
          categoriasSet.add(item.categoriaServicio);
        });

      const categorias = [...categoriasSet];

      this.arrayCategoriasOfService.push({ tipo, categorias });
    }
    const tipoSeleccionado = this.arrayCategoriasOfService?.find(
      (tipo) => tipo.tipo === 'ENTRADA'
    );
    this.categoriasFiltradas = tipoSeleccionado
      ? tipoSeleccionado.categorias
      : [];

    console.log('Services');
    console.log('this.arrayCategoriasOfService', this.arrayCategoriasOfService);
    console.log(this.model);
    //   return allServices;
    // },
    // complete: () => {
    this.model?.map((fila: any) => {
      fila.checked = false;
    });
    this.fileDataSource = new MatTableDataSource(this.model);

    this.fileDataSource.sort = this.sort;
    this.changeDetectorRefs.detectChanges();
    this.loader = false;
    this.applyFilterSelect();
    //   },
    // });
  }

  openDialogPdfOS(id: any): void {
    const num = Number(id);

    let dialogRef = this.dialog.open(DialogPdfComponent, {
      width: '1300px',
      height: '1000px',
      data: { num }
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('The dialog was closed');
      // this.animal = result;
    });
  }

  applyFilter(event: Event) {
    let filterValue = (event.target as HTMLInputElement).value;
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.fileDataSource.filter = filterValue;
  }

  onGo(i: string) {
    this.router.navigate(['/file', i]);
  }
  addDaysToDate(date: any, days: any): any {
    var res = new Date(date);
    res.setDate(res.getDate() + days);
    return res;
  }

  traslateEstado(estado: String | null) {
    if (estado === 'SENT') {
      return 'ENVIADO';
    } else if (estado === 'CONFIRMED') {
      return 'CONFIRMADO';
    } else if (estado === 'DENIED') {
      return 'DENEGADO';
    } else if (estado === 'STANDBY') {
      return 'EN ESPERA';
    } else {
      return estado;
    }
  }

  transformDate(date: String, day: String) {
    const days = date.split('/')[0];
    const months = date.split('/')[1];
    const year = date.split('/')[2];

    var tmpDate = new Date(Number(year), Number(months), Number(days));
    const dateRpst = new Date(
      this.addDaysToDate(tmpDate, Number(Number(day) - 1))
    );
    // console.log(Date.UTC(Number(year), Number(months), Number(days)))
    const options: any = { year: 'numeric', month: 'numeric', day: 'numeric' };
    const formattedDate = dateRpst.toLocaleDateString(options);
    return formattedDate;
  }

  changeValue(tipoFile: string | null) {
    if (tipoFile) {
      this.selectedFile = tipoFile;
      this.fileDataSource.data = this.dataItinial.filter(
        (itemFilter) =>
          itemFilter.estadoFile ===
          (this.selectedFile === 'FILE' ? null : this.selectedFile)
      );
      console.log('list', this.fileDataSource.data);
    } else {
      this.fileDataSource.data = this.dataItinial;
      this.selectedFile = 'BORRAR';
    }
  }

  showFiltersFx() {
    this.filtersSecction = !this.filtersSecction;
    console.log(this.filtersSecction);
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.model.map((fila: any) => {
        fila.checked = false;
      });
      console.log(
        'verifica checked',
        this.model.filter((x: any) => x.checked == true)
      );
      this.estadoBtnMasivo = 0;
      return;
    } else {
      this.model.map((fila: any) => {
        fila.checked = !fila.checked;
      });
      console.log(
        'verifica checked',
        this.model.filter((x: any) => x.checked == true)
      );
      this.estadoBtnMasivo = this.model.length;
      return;
    }
  }

  isAllSelected() {
    let lstHoteles: any[];
    lstHoteles = this.fileDataSource.data.filter((x: any) => x.checked == true);
    const numSelected = lstHoteles.length;
    const numRows = this.fileDataSource.data.length;
    return numSelected === numRows;
  }
  searchValue: null | string = '';
  pageSize: number = 5;
  currentPage = 0;

  totalItems: number = 0;

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.applyFilterSelect();
  }

  updatePaginatedData() {
    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
    // this.paginatedData = this.dataFiles.slice(start, end);
  }

  applyFilterSelect() {
    let dataNew: any = this.model;

    if (this.searchValue && this.searchValue.trim() !== '') {
      const terms = this.searchValue
        .toLowerCase()
        .split(' ')
        .filter((t) => t);

      dataNew = dataNew.filter((item: any) => {
        const allValues = flattenStrings(item);
        return terms.every((term) =>
          allValues.some((val) => val.includes(term))
        );
      });
    }

    if (this.selectNumberFile) {
      console.log(this.selectNumberFile);
      dataNew = dataNew?.filter(
        (item: any) => item.fileNumber == this.selectNumberFile
      );
      // dataNew = dataNew?.filter((item: any) => this.toppings?.value?.includes(item.fileNumber))
    }

    if (this.daySelected) {
      dataNew = dataNew?.filter((item: any) => item.day === this.daySelected);
    }

    if (this.selectService) {
      dataNew = dataNew?.filter(
        (item: any) => item.nombreServicio === this.selectService
      );
    }
    if (this.typeOfServiceSelected) {
      dataNew = dataNew?.filter(
        (item: any) => item.tipoServicio === this.typeOfServiceSelected
      );
    }
    if (this.selectedCliente) {
      dataNew = dataNew?.filter(
        (item: any) => item.fileName === this.selectedCliente
      );
    }
    if (this.selectProveedor) {
      dataNew = dataNew?.filter(
        (item: any) => item.objProvider.nombre === this.selectProveedor
      );
    }
    if (this.categoriaOfServiceSelected) {
      dataNew = dataNew?.filter(
        (item: any) =>
          item.categoriaServicio === this.categoriaOfServiceSelected
      );
    }
    if (this.selectDate) {
      dataNew = dataNew?.filter((item: any) => item.date === this.selectDate);
    }

    if (this.selectClient) {
      dataNew = dataNew?.filter(
        (item: any) => item.fileName === this.selectClient
      );
    }

    if (this.selectNumOS) {
      dataNew = dataNew?.filter((item: any) => item.numOS === this.selectNumOS);
    }

    if (this.selectEstadoOS) {
      dataNew = dataNew?.filter(
        (item: any) =>
          this.traslateEstado(item.estadoReserva) === this.selectEstadoOS
      );
    }
    if (this.selectEstadoFile) {
      dataNew = dataNew?.filter(
        (item: any) => item.fileDisplayState === this.selectEstadoFile
      );
    }

    if (this.startDateSelected && this.endDateSelected) {
      console.log(this.startDateSelected);
      console.log(dataNew[0].date);
      console.log(dataNew[0].dateToShow);
      console.log(moment(dataNew[0].date, 'MM.DD.YYYY').toDate());
      dataNew = dataNew?.filter(
        (item: any) =>
          new Date(this.startDateSelected) <=
            moment(item.dateToShow, 'DD.MM.YYYY').toDate() &&
          moment(item.dateToShow, 'DD.MM.YYYY').toDate() <=
            new Date(this.endDateSelected)
      );

      console.log(
        new Date(this.startDateSelected),
        new Date(this.endDateSelected)
      );
    }

    // console.log(dataNew);
    // this.fileDataSource.data = dataNew;

    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
    this.totalItems = dataNew?.length;

    this.fileDataSource.data = dataNew.slice(start, end);
    if (this.paginator) {
      this.paginator.length = this.totalItems;
    }
  }
  transformDay(range: String, toDay: number) {
    const firstDate = range?.split('-')?.[0]?.trim();
    console.log(firstDate);
    const days = firstDate.split('/')[0];
    const months = firstDate.split('/')[1];
    const year = firstDate.split('/')[2];

    console.log(months + '/' + days + '/' + year);

    var result = new Date(months + '/' + days + '/' + year);
    result.setDate(result.getDate() - toDay);
    console.log(result);
    return result.toString();
  }

  transformDateShow(range: String) {
    const firstDate = range?.split('-')?.[0]?.trim();
    console.log(firstDate);
    const days = firstDate.split('/')[0];
    const months = firstDate.split('/')[1];
    const year = firstDate.split('/')[2];

    console.log(months + '/' + days + '/' + year);

    var result = new Date(months + '/' + days + '/' + year);

    return result.toString();
  }

  onApplyRangeSelected() {
    console.log(this.startDate);

    console.log({
      start: this.getDateTransform(JSON.stringify(new Date(this.startDate))),
      end: this.getDateTransform(JSON.stringify(new Date(this.endDate)))
    });
    this.startDateSelected = this.getDateTransform(
      JSON.stringify(new Date(this.startDate))
    );
    this.endDateSelected = this.getDateTransform(
      JSON.stringify(new Date(this.endDate))
    );
    this.applyFilterSelect();
  }

  getDateTransform(date: string) {
    const dateSeparated = date.slice(1, 11).split('-');
    const month = dateSeparated[1];
    const day = dateSeparated[2];
    const year = dateSeparated[0];
    return month + '/' + day + '/' + year;
  }

  cleanDateSelected(val: any) {
    console.log(val);
    if (val == 1) {
      this.startDate = null;
      this.startDateSelected = null;
      this.endDate = null;
      this.endDateSelected = null;
    } else if (val == 2) {
      this.startDate2 = null;
      this.startDateSelected2 = null;
      this.endDate2 = null;
      this.endDateSelected2 = null;
    }

    this.applyFilterSelect();
  }

  openDialog(element: any) {
    console.log(element);
    let dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      fileId: element.fileNumber,
      serviceType: 4,
      reservaId: element.numOS,
      hasDocument: element.hasDocument
    };
    dialogConfig.width = '1000px';
    dialogConfig.minHeight = '379px';
    dialogConfig.maxHeight = '900px';

    let dialogRef = this.dialog.open(
      DialogArchivosReservasComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        element.hasDocument = result.changeIconColor;
      }
    });
  }
}
